import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "chargeback_guide",
  tabindex: "1",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog mw-650px" }
const _hoisted_3 = { class: "card card-body" }
const _hoisted_4 = { class: "card-title ps-7 pt-5 fs-5 fw-bolder" }
const _hoisted_5 = {
  key: 0,
  src: "/media/svg/card-logos/visa.svg",
  alt: "",
  class: "h-25px pe-5"
}
const _hoisted_6 = {
  key: 1,
  src: "/media/svg/card-logos/american-express.svg",
  alt: "",
  class: "h-25px pe-5"
}
const _hoisted_7 = {
  key: 2,
  src: "/media/svg/card-logos/mastercard.svg",
  alt: "",
  class: "h-25px pe-5"
}
const _hoisted_8 = {
  key: 3,
  src: "/media/svg/card-logos/discovercard.svg",
  alt: "",
  class: "h-25px pe-5"
}
const _hoisted_9 = { class: "mh-300px m-5 py-5" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "card-title" }, [
  /*#__PURE__*/_createElementVNode("h4", { class: "fw-bolder py-4" }, "What you'll need.")
], -1)
const _hoisted_11 = { class: "d-flex align-items-center" }
const _hoisted_12 = { class: "ms-5" }
const _hoisted_13 = { class: "fw-bold text-gray-800" }
const _hoisted_14 = { class: "mh-300px m-5 py-5" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "card-title" }, [
  /*#__PURE__*/_createElementVNode("h4", { class: "fw-bolder py-4" }, "Available Response Pages")
], -1)
const _hoisted_16 = { class: "d-flex align-items-center" }
const _hoisted_17 = { class: "ms-5" }
const _hoisted_18 = { class: "fw-bold text-gray-800" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (_ctx.reason.card_brand === 'Visa')
            ? (_openBlock(), _createElementBlock("img", _hoisted_5))
            : _createCommentVNode("", true),
          (_ctx.reason.card_brand === 'American Express')
            ? (_openBlock(), _createElementBlock("img", _hoisted_6))
            : _createCommentVNode("", true),
          (_ctx.reason.card_brand === 'Mastercard')
            ? (_openBlock(), _createElementBlock("img", _hoisted_7))
            : _createCommentVNode("", true),
          (_ctx.reason.card_brand === 'Discover')
            ? (_openBlock(), _createElementBlock("img", _hoisted_8))
            : _createCommentVNode("", true),
          _createTextVNode(" " + _toDisplayString(_ctx.reason.code) + " " + _toDisplayString(_ctx.reason.message), 1)
        ]),
        _createElementVNode("div", _hoisted_9, [
          _hoisted_10,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.reason_explained.instructions.details, (msg, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: "d-flex flex-stack py-4 border-bottom border-gray-300 border-bottom-dashed"
            }, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, _toDisplayString(msg), 1)
                ])
              ])
            ]))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_14, [
          _hoisted_15,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.reason_explained.instructions.evidence, (msg, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: "d-flex flex-stack py-4 border-bottom border-gray-300 border-bottom-dashed"
            }, [
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("div", _hoisted_18, _toDisplayString(msg), 1)
                ])
              ])
            ]))
          }), 128))
        ])
      ])
    ])
  ]))
}